<app-telematics-histroy [entityData]="entityData"></app-telematics-histroy>